const footerSection = {
    FooterSection: {
        baseStyle: () => ({
            section: {
                gap: 'spacing.6',
            },
            sectionContent: {
                gap: {md: 'spacing.4'},
            },
            sectionTitle: {
                textStyle: 'paragraphMd',
                fontWeight: 500,
            },
            sectionItem: {
                textStyle: {base: 'paragraphXl', md: 'paragraphSm'},
                width: {md: 'fit-content'},
                py: {base: 'spacing.3', md: 0},
            },
        }),
    },
}

export default footerSection
